// import React, { useState } from 'react';

// // UI Components
// const Button = ({ children, onClick, disabled }) => (
//   <button
//     className="px-4 py-2 bg-blue-500 text-white rounded disabled:bg-gray-300"
//     onClick={onClick}
//     disabled={disabled}
//   >
//     {children}
//   </button>
// );

// const Card = ({ children }) => <div className="p-4 border rounded shadow">{children}</div>;

// const CardContent = ({ children }) => <div>{children}</div>;

// const Table = ({ children }) => (
//   <table className="w-full border-collapse border">{children}</table>
// );

// const Input = ({ ...props }) => (
//   <input className="border p-2 w-full mb-4" {...props} />
// );

// const App = () => {
//   const [data, setData] = useState([]);
//   const [uploading, setUploading] = useState(false);
//   const [sending, setSending] = useState(false);
//   const [statusMap, setStatusMap] = useState({});

//   // Handle CSV Upload
//   const handleFileUpload = async (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     setUploading(true);

//     const reader = new FileReader();
//     reader.onload = (e) => {
//       const text = e.target.result;
//       const rows = text
//         .split('\n')
//         .map((row) => row.split(','))
//         .filter(([name, email, user, pass]) => name && email && user && pass);

//       setData(rows);
//       setStatusMap(
//         rows.reduce(
//           (acc, [name, email]) => ({
//             ...acc,
//             [email]: 'Pending',
//           }),
//           {}
//         )
//       );

//       setUploading(false);
//     };

//     reader.readAsText(file);
//   };

//   // Start Sending Emails
//   const startSending = () => {
//     if (data.length === 0) {
//       alert('No data uploaded!');
//       return;
//     }

//     setSending(true);
//     let index = 0;

//     const sendEmail = () => {
//       if (index >= data.length) {
//         setSending(false);
//         return;
//       }

//       const [name, email, user, pass] = data[index];

//       console.log("📤 Sending email with:", { name, email, user, pass });

//       fetch('http://localhost:5000/send-email', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ name, email, user, pass }),
//       })
//         .then((response) => {
//           if (response.ok) {
//             setStatusMap((prev) => ({ ...prev, [email]: 'Sent' }));
//           } else {
//             setStatusMap((prev) => ({ ...prev, [email]: 'Failed' }));
//           }
//         })
//         .catch(() => {
//           setStatusMap((prev) => ({ ...prev, [email]: 'Failed' }));
//         })
//         .finally(() => {
//           index++;
//           setTimeout(sendEmail, 3000); // 3 seconds delay
//         });
//     };

//     sendEmail();
//   };

//   return (
//     <div className="p-4">
//       <Card className="max-w-2xl mx-auto">
//         <CardContent>
//           <h1 className="text-xl font-bold mb-4">Email Sender App</h1>

//           {/* File Upload */}
//           <div className="mb-4">
//             <Input
//               type="file"
//               accept=".csv"
//               onChange={handleFileUpload}
//               disabled={uploading}
//             />
//             {uploading && (
//               <p className="text-sm text-gray-500 mt-2">Uploading...</p>
//             )}
//           </div>

//           {/* Start Button */}
//           <Button onClick={startSending} disabled={sending || uploading}>
//             {sending ? 'Sending...' : 'Start Sending Emails'}
//           </Button>

//           {/* Email Status Table */}
//           <div className="mt-6">
//             <Table>
//               <thead>
//                 <tr>
//                   <th className="border px-4 py-2">Name</th>
//                   <th className="border px-4 py-2">Email</th>
//                   <th className="border px-4 py-2">Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {data.map(([name, email]) => (
//                   <tr key={email}>
//                     <td className="border px-4 py-2">{name}</td>
//                     <td className="border px-4 py-2">{email}</td>
//                     <td className="border px-4 py-2">{statusMap[email]}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </div>
//         </CardContent>
//       </Card>
//     </div>
//   );
// };

// export default App;

// new/
import React, { useState } from 'react';

// UI Components
const Button = ({ children, onClick, disabled }) => (
  <button
    className="px-4 py-2 bg-blue-500 text-white rounded disabled:bg-gray-300"
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

const Card = ({ children }) => <div className="p-4 border rounded shadow">{children}</div>;

const CardContent = ({ children }) => <div>{children}</div>;

const Table = ({ children }) => (
  <table className="w-full border-collapse border">{children}</table>
);

const Input = ({ ...props }) => (
  <input className="border p-2 w-full mb-4" {...props} />
);

const App = () => {
  const [data, setData] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [sending, setSending] = useState(false);
  const [statusMap, setStatusMap] = useState({});

  // Handle CSV Upload
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploading(true);

    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      const rows = text
        .split('\n')
        .map((row) => row.split(',').map(value => value.trim())) // Trim spaces
        .filter(([name, email, user, pass]) => name && email && user && pass); // Ensure all fields exist

      console.log("📜 CSV Data Loaded:", rows); // Debug CSV content

      setData(rows);
      setStatusMap(
        rows.reduce((acc, [name, email]) => ({ ...acc, [email]: 'Pending' }), {})
      );

      setUploading(false);
    };

    reader.readAsText(file);
  };

  // Start Sending Emails
  const startSending = () => {
    if (data.length === 0) {
      alert('No data uploaded!');
      return;
    }

    setSending(true);
    let index = 0;

    const sendEmail = () => {
      if (index >= data.length) {
        setSending(false);
        return;
      }

      const [name, email, user, pass] = data[index];

      console.log("📤 Sending email with:", { name, email, user, pass });

      fetch('http://localhost:5000/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, user, pass }),
      })
        .then((response) => {
          if (response.ok) {
            setStatusMap((prev) => ({ ...prev, [email]: 'Sent' }));
          } else {
            setStatusMap((prev) => ({ ...prev, [email]: 'Failed' }));
          }
        })
        .catch(() => {
          setStatusMap((prev) => ({ ...prev, [email]: 'Failed' }));
        })
        .finally(() => {
          index++;
          setTimeout(sendEmail, 3000); // 3 seconds delay
        });
    };

    sendEmail();
  };

  return (
    <div className="p-4">
      <Card className="max-w-2xl mx-auto">
        <CardContent>
          <h1 className="text-xl font-bold mb-4">Email Sender App</h1>

          {/* File Upload */}
          <div className="mb-4">
            <Input
              type="file"
              accept=".csv"
              onChange={handleFileUpload}
              disabled={uploading}
            />
            {uploading && (
              <p className="text-sm text-gray-500 mt-2">Uploading...</p>
            )}
          </div>

          {/* Start Button */}
          <Button onClick={startSending} disabled={sending || uploading}>
            {sending ? 'Sending...' : 'Start Sending Emails'}
          </Button>

          {/* Email Status Table */}
          <div className="mt-6">
            <Table>
              <thead>
                <tr>
                  <th className="border px-4 py-2">Name</th>
                  <th className="border px-4 py-2">Email</th>
                  <th className="border px-4 py-2">Status</th>
                </tr>
              </thead>
              <tbody>
                {data.map(([name, email]) => (
                  <tr key={email}>
                    <td className="border px-4 py-2">{name}</td>
                    <td className="border px-4 py-2">{email}</td>
                    <td className="border px-4 py-2">{statusMap[email]}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default App;
